/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invalid_Weight_GramsInputs */

const vi_error_invalid_weight_grams = /** @type {(inputs: Error_Invalid_Weight_GramsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Định lượng lọc sản phẩm không hợp lệ. Nhập định lượng là số gam lớn hơn 0 rồi chọn lại.`)
};

/**

* @param {Error_Invalid_Weight_GramsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_invalid_weight_grams = /** @type {((inputs?: Error_Invalid_Weight_GramsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invalid_Weight_GramsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_invalid_weight_grams(inputs)
});